// extracted by mini-css-extract-plugin
module.exports = {"extendedCodemirror":"codemirror_extendedCodemirror__nRQWH","no-ligatures":"codemirror_no-ligatures__zl58e"};